export var PeriodUnit;
(function (PeriodUnit) {
    PeriodUnit["UNDEFINED"] = "UNDEFINED";
    PeriodUnit["DAY"] = "DAY";
    PeriodUnit["WEEK"] = "WEEK";
    PeriodUnit["MONTH"] = "MONTH";
    PeriodUnit["YEAR"] = "YEAR";
})(PeriodUnit || (PeriodUnit = {}));
export var AppliedAt;
(function (AppliedAt) {
    AppliedAt["UNKNOWN_CHARGE_EVENT"] = "UNKNOWN_CHARGE_EVENT";
    /** Will charge the fee on first payment. If order has a free trial meaning it will charge after the free trial. */
    AppliedAt["FIRST_PAYMENT"] = "FIRST_PAYMENT";
})(AppliedAt || (AppliedAt = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var ArchivedFilter;
(function (ArchivedFilter) {
    /** Returns all plans that are active. */
    ArchivedFilter["ACTIVE"] = "ACTIVE";
    /** Returns all plans that are archived. */
    ArchivedFilter["ARCHIVED"] = "ARCHIVED";
    /** Returns all plans that are active and archived. */
    ArchivedFilter["ARCHIVED_AND_ACTIVE"] = "ARCHIVED_AND_ACTIVE";
})(ArchivedFilter || (ArchivedFilter = {}));
export var PublicFilter;
(function (PublicFilter) {
    /** Returns all public and hidden plans. */
    PublicFilter["PUBLIC_AND_HIDDEN"] = "PUBLIC_AND_HIDDEN";
    /** Returns only public plans. */
    PublicFilter["PUBLIC"] = "PUBLIC";
    /** Returns only hidden plans. */
    PublicFilter["HIDDEN"] = "HIDDEN";
})(PublicFilter || (PublicFilter = {}));
//# sourceMappingURL=types.impl.js.map